import React from 'react';
import axiosDefault from '../axios';

export function useQuery(config, axios = axiosDefault) {
    const [state, setState] = React.useState({
        data: undefined,
        rows: [],
        isLoading: false,
    });
    const call = async () => {
        setState({ ...state, isLoading: true });
        const { data } = await axios(config);
        setState({ ...state, isLoading: false, data });
    };
    return { ...state, call };
}
